export default __webpack_public_path__ + "static/media/user (1).0d58388a.svg";